import * as types from './mutation-types'

const mutations = {
  [types.SET_MSG_LIST] (state, msgList) {
    state.msgList = msgList
  },
  [types.SET_NOTIFY_COUNT] (state, notifyCount) {
    state.notifyCount = notifyCount
  },
  [types.SET_UNREAD_MSG] (state, unReadMsg) {
    state.unReadMsg = unReadMsg
  },
  [types.SET_TOKEN] (state, token) {
    state.token = token
  },
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_MEMBER_EXT] (state, memberExt) {
    state.memberExt = memberExt
  },
  [types.SET_INFO_COMPLETERATE] (state, infoCompleteRate) {
    state.infoCompleteRate = infoCompleteRate
  },
  [types.SET_SETTING] (state, setting) {
    state.setting = setting
  },
  [types.SET_EDIT_ADDRESS] (state, editAddress) {
    state.editAddress = editAddress
  },
  [types.SET_CITYS] (state, citys) {
    state.citys = citys
  },
  [types.SET_REGISTER] (state, register) {
    state.register = register
  },
  [types.SET_FORGET] (state, forget) {
    state.forget = forget
  },
  [types.SET_UPDATE_PHONE] (state, updatePhone) {
    state.updatePhone = updatePhone
  },
  [types.SET_IS_COMMUNICATE] (state, isCommunicate) {
    state.isCommunicate = isCommunicate
  },
  [types.SET_UNREAD_LIKE_MSG] (state, likeMsg) {
    state.likeMsg = likeMsg
  },
  [types.SET_UNREAD_COMMENT_MSG] (state, commentMsg) {
    state.commentMsg = commentMsg
  },
  [types.SET_UNREAD_WALLET_MSG] (state, walletMsg) {
    state.walletMsg = walletMsg
  },
  [types.SET_UNREAD_FOLLOW_MSG] (state, followMsg) {
    state.followMsg = followMsg
  },
  [types.SET_VIDEO] (state, video) {
    state.video = video
  },
  [types.SET_SOCIAL_DATA] (state, socialData) {
    state.socialData = socialData
  },
  [types.SET_MY_POSTION] (state, myPosition) {
    state.myPosition = myPosition
  },
  [types.SET_UPLOAD_TASK] (state, uploadTask) {
    state.uploadTask = uploadTask
  },
  [types.SET_PRODUCT] (state, product) {
    state.product = product
  },
  [types.SET_ORDER] (state, order) {
    state.order = order
  },
  [types.SET_USER_INFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_REWARD] (state, reward) {
    state.reward = reward
  },
  [types.SET_READ_ARTICLE] (state, readArticleList) {
    state.readArticleList = readArticleList
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js